/**
 * Contact sidebar UI component
 * @param  data 
 * @returns 
 * data : Array
 * Example:
    contactPage:
    title: "Plant a tree for Tree Week"
    url: "plant-a-tree-for-tree-week"
    contactSidebar:
    contactDetails:
    contact:
    address: "<p>Head Office<br />↵Bradley Stoke Leisure Centre<br />↵Fiddlers Wood Lane<br />↵Bradley Stoke<br />↵South Gloucestershire<br />↵BS32 9BS</p>↵"
    email: "headoffice@circadiantrust.org"
    telephone: "0300 3330300"
    website: null
    id: "cG9zdDo0MTA4NA=="
    title: "Active Leisure"
    __typename: "WpQl_contact"
    contactDetailsHideAddress: true
    contactDetailsHideEmail: null
    contactDetailsHideTelephone: true
    @todo come back to this and use normal dangerously set instead of that dependancy
*/

import React, { useState } from "react"
import md5 from "md5"
//import InnerHTML from 'dangerously-set-html-content'
import _ from "lodash"

function ContactCallout(data) {
  let contactData = data.data
  const [isActive, setActive] = useState("false")
  const handleAllToggle = () => {
    setActive(!isActive)
  }

  const html = `


var outputController = (function(){
    function getEnquiryName(){
    return document.getElementById('enquiry_name').value;
    }
    function getEnquiryEmail(){
    return document.getElementById('enquiry_email').value;
    }
    function getEnquiryMessage(){
    return document.getElementById('enquiry-comments').value;
    }
    function applyFields(name,email,message){
      document.getElementById('enquiry_body_text').value = 
          'Reference: ' + document.getElementById('reference_number').value +'[NL][NL]'+
          'Page: ' + document.getElementById('referring_page').value +'[NL][NL]'+
          'URL: ' + document.getElementById('referring_url').value +'[NL][NL]'+
          'Name: ' + name() +'[NL][NL]'+
          'Email: ' + email() +'[NL][NL]'+
          'Message: ' + message() +'[NL][NL]'
      
  
      }
    function setListeners(){
    document.getElementById('enquiry_name').addEventListener('keyup', function(){
    applyFields(getEnquiryName, getEnquiryEmail, getEnquiryMessage);
    });
    document.getElementById('enquiry_email').addEventListener('keyup', function(){
    applyFields(getEnquiryName, getEnquiryEmail, getEnquiryMessage);      
    });
    document.getElementById('enquiry-comments').addEventListener('keyup', function(){
    applyFields(getEnquiryName, getEnquiryEmail, getEnquiryMessage);      
    });
    } 
    return {
    init: function(){
    setListeners();
    }
    }
    })();
    outputController.init();

`

  const ReferenceNumber = "SGC/" + md5(Date.now())
  //console.log(contactData.contactSidebar)
  return (
    <>
      {contactData.contactSidebar.contactDetails &&
        !_.isNil(contactData.contactSidebar.contactDetails.contact) && (
          <div
            className="contact-links dont-print"
            aria-label="Contact information"
          >
            <div className="element--inner">
              <p className="heading contact-links__heading">Contact</p>
              {
                /**
                 * If contactDetailsHideTelephone == true then SHOULD be rendered on this post
                 * If telephone is  not undefined then render it.
                 *
                 * If the 2 conditions are met (contactDetailsHideTelephone == true and telephone !== undefined) then display
                 */
                (!contactData.contactSidebar.contactDetailsHideTelephone ||
                  (!_.isNil(
                    contactData.contactSidebar.contactDetails.contact
                  ) &&
                    !_.isNil(
                      contactData.contactSidebar.contactDetails.contact
                        .telephone
                    ) &&
                    !contactData.contactSidebar
                      .contactDetailsHideTelephone)) && (
                  <p>
                    <a
                      href={
                        "tel:" +
                        contactData.contactSidebar.contactDetails.contact
                          .telephone
                      }
                      title="Call us"
                    >
                      <i className="icon-telephone"></i>
                      {
                        contactData.contactSidebar.contactDetails.contact
                          .telephone
                      }
                    </a>
                  </p>
                )
              }

              {
                /**
                 * If contactDetailsHideEmail == true then SHOULD be rendered on this post
                 * If email is  not undefined then render it.
                 *
                 * If the 2 conditions are met (contactDetailsHideEmail == true and telephone !== email) then display
                 *
                 * @todo change localhost to SITE.ENV
                 */
                (!contactData.contactSidebar.contactDetailsHideEmail ||
                  (!_.isNil(
                    contactData.contactSidebar.contactDetails.contact
                  ) &&
                    !_.isNil(
                      contactData.contactSidebar.contactDetails.contact.email
                    ) &&
                    !contactData.contactSidebar.contactDetailsHideEmail)) && (
                  <>
                    <a
                      onClick={handleAllToggle}
                      id={"EnquiryFormTrigger-" + ReferenceNumber}
                      title="Make an enquiry"
                      className="underline-link"
                      rel="nofollow"
                    >
                      <i className="icon-email"></i>Make an enquiry
                    </a>
                    <div
                      id={"enquiryForm-" + ReferenceNumber}
                      className={
                        isActive
                          ? "enquiry-form-component enquiry-form hidden"
                          : "enquiry-form-component enquiry-form"
                      }
                    >
                      <form
                        action="https://webapps.southglos.gov.uk/formmail/"
                        method="POST"
                      >
                        <input type="hidden" name="hp" id="hp" />
                        <input
                          type="hidden"
                          name="page_contact"
                          value={
                            contactData.contactSidebar.contactDetails.contact
                              .email
                          }
                        />
                        <input
                          type="hidden"
                          name="cc_address"
                          value="website-enquiries@southglos.gov.uk"
                        />
                        <input
                          type="hidden"
                          id="enquiry_subject"
                          name="subject"
                          value={ReferenceNumber + " Website enquiry"}
                        ></input>
                        <input
                          type="hidden"
                          id="reference_number"
                          name="reference_number"
                          value={ReferenceNumber}
                        />
                        <input
                          type="hidden"
                          id="referring_page"
                          name="referring_page"
                          value={contactData.contactPage.title}
                        />
                        <input
                          type="hidden"
                          id="referring_url"
                          name="referring_url"
                          value={`https://beta.southglos.gov.uk/${contactData.contactPage.url}`}
                        />
                        <input
                          type="hidden"
                          id="enquiry_redirect_success"
                          name="redirect_success"
                          value={
                            "https://beta.southglos.gov.uk/" +
                            contactData.contactPage.url +
                            "?enquiry=1"
                          }
                        />
                        <input
                          type="hidden"
                          id="enquiry_redirect_error"
                          name="redirect_error"
                          value={
                            "https://beta.southglos.gov.uk/" +
                            contactData.contactPage.url +
                            "?enquiry=0"
                          }
                        />
                        <div className="form-group">
                          <label htmlFor="enquiry_name">Your name</label>
                          <input
                            id="enquiry_name"
                            name="enquiry_name"
                            type="text"
                            className="form-control"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="enquiry_email">
                            Your email address
                          </label>
                          <input
                            id="enquiry_email"
                            name="enquiry_email"
                            type="email"
                            className="form-control"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="enquiry-comments">Your enquiry</label>
                          <textarea
                            id="enquiry-comments"
                            name="enquiry-comments"
                            className="form-control"
                            rows="3"
                            required
                          ></textarea>
                          <textarea
                            title="Enquiry"
                            id="enquiry_body_text"
                            name="body_text"
                            className="form-control hidden"
                            rows="3"
                            arai-hidden="true"
                          ></textarea>
                        </div>
                        <button
                          type="submit"
                          className="button button--primary button__small"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </>
                )
              }

              <div className="contact-links__address">
                {!_.isNil(
                  contactData.contactSidebar.contactDetails.contact.website
                ) && (
                  <a
                    href={
                      contactData.contactSidebar.contactDetails.contact.website
                    }
                    title={
                      "Go to " +
                      contactData.contactSidebar.contactDetails.contact.website
                    }
                  >
                    <i className="fa fa-url"></i>
                    {contactData.contactSidebar.contactDetails.contact.website}
                  </a>
                )}
                {!contactData.contactSidebar.contactDetailsHideAddress &&
                  !_.isNil(
                    contactData.contactSidebar.contactDetails.contact.address
                  ) && (
                    <div
                      className="address-details"
                      dangerouslySetInnerHTML={{
                        __html:
                          contactData.contactSidebar.contactDetails.contact
                            .address,
                      }}
                    />
                  )}
              </div>
            </div>
            {/** <InnerHTML html={html} /> */}

            <script
              type="text/javascript"
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />
          </div>
        )}
    </>
  )
}
export default ContactCallout
